export default "__VITE_ASSET__CnNfwvbu__"